import { Box } from "@mui/material";
import { keyframes } from "@mui/system";

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export function BrandSpinner({ size = 84 }) {
  return (
    <Box
      role="status"
      aria-label="Loading"
      sx={{
        display: "grid",
        width: size,
        height: size,
        placeItems: "center",
        mx: "auto",
      }}
    >
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/brand/spend2connect-logo.png`}
        alt="Spend2Connect loading"
        sx={{
          display: "block",
          width: size,
          height: size,
          maxWidth: "none",
          objectFit: "contain",
          animation: `${spin} 0.95s linear infinite`,
          transformOrigin: "center center",
        }}
        onLoad={() => {
          console.log("Spend2Connect loader image loaded");
        }}
        onError={(event) => {
          console.error(
            "Spend2Connect loader image failed:",
            event.currentTarget.src,
          );
        }}
      />
    </Box>
  );
}